import { Attachment } from 'types/Attachment';
import { PaginationParams, SortParams } from 'types/Pagination';

export enum OperationStatus {
  Eligible = 'Éligible',
  AConfirmer = 'Éligibilité à confirmer',
  NonConfirme = 'Eligibilité non-confirmée à ce stade',
  Recommandations = 'Recommandations',
  Annule = 'Annulé',
  DossierEnCoursDeValidation = 'Dossier en cours de validation',
  Incomplet = 'Incomplet',
  RemisAuControle = 'Remis au contrôle',
  PreValide = 'Pré validé',
  BonPourPrime = 'Bon pour Prime',
  NonConforme = 'Non-conforme (Qualité)',
  ActionEnCours = 'Actions en cours',
  Litige = 'Litige',
  Refuse = 'Refusé',
}

export enum OperationSortFields {
  libelle = 'libelle',
  fost = 'fost',
  montantPrime = 'montantPrime',
  statut = 'statut',
}

export const OperationStatusKeys = Object.fromEntries(
  Object.entries(OperationStatus).map(([key, value]) => [
    value.toLowerCase(),
    key,
  ]),
);

export interface OperationHistoryItem {
  date: string;
  value: OperationStatus;
}

export interface AHManagement {
  enabled: boolean;
  canGenerate: boolean;
  canDownload: boolean;
  canView: boolean;
  ahAttachmentId: string | null;
}

export interface Operation {
  id: string;
  libelle?: string;
  fost?: string;
  montantPrime?: number;
  statut?: OperationStatus;
  statutPaiementBF?: string;
  ahManagement?: AHManagement;
}

export interface AttestationHonneurSignataire {
  lastname?: string;
  firstname?: string;
  title?: string;
  email?: string;
  phone?: string;
}

export interface AHSignataireData {
  firstname: string;
  lastname: string;
  title: string;
  email: string;
  phone: string;
}

export interface AHDataResponse {
  ahManagement: AHManagement;
  dateMiseEnService: string | null;
  beneficiaire: AHSignataireData;
  professionnel: AHSignataireData;
  gestionnaireReseau: AHSignataireData;
}

export interface AttestationHonneurData {
  dateMiseEnService?: string;
  beneficiaireSignataire?: AttestationHonneurSignataire;
  professionnelSignataire?: AttestationHonneurSignataire;
  gestionnaireReseauSignataire?: AttestationHonneurSignataire;
}

export interface OperationFull extends Operation {
  criteresEligibilite?: string;
  mentionsFacture?: string;
  pointsVigilance?: string;
  pointsControleSite?: string;
  reference: string;
  date: string;
  datePrevisionnelleDevis?: string;
  immatriculation: string;
  identification: string;
  typeVarianteVersion?: string;
  attestationHonneur?: AttestationHonneurData;
}

export interface OperationDetails {
  operation: OperationFull;
  history: OperationHistoryItem[];
  attachments: Attachment[];
}

export interface Operations {
  records: OperationFull[];
  totalSize: number;
}

export interface OperationsSearchParams
  extends PaginationParams, SortParams<OperationSortFields> {}

export enum SecteurOperations {
  INDUSTRIE = 'Industrie',
  RESEAUX = 'Réseaux',
  TERTIAIRE = 'Tertiaire',
  AGRICULTURE = 'Agriculture',
  RESIDENTIEL = 'Résidentiel',
}
